import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { TeamOutput } from "~@/graphql/codegen/generated";

export enum TeamMethod {
  Update = "update",
  Create = "create",
  Delete = "delete",
}

interface TeamsState {
  selectedTeam?: TeamOutput;
  teamMethod: TeamMethod;
}

const initialState: TeamsState = {
  selectedTeam: undefined,
  teamMethod: TeamMethod.Update,
};

const teamsSlice = createSlice({
  name: "teams",
  initialState,
  reducers: {
    setSelectedTeam(state, action: PayloadAction<TeamOutput | undefined>) {
      state.selectedTeam = action.payload;
    },
    clearSelectedTeam(state) {
      state.selectedTeam = undefined;
    },
    setTeamMethod(state, action: PayloadAction<TeamMethod>) {
      state.teamMethod = action.payload;
    },
  },
});

export const { setSelectedTeam, clearSelectedTeam, setTeamMethod } =
  teamsSlice.actions;

export default teamsSlice.reducer;
